import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/app/app.constants';
import { Observable } from 'rxjs';
import { CheckpointTemplateViewModel } from '../../models/peaps/checkpointTemplate';
import { ValidatedViewModel } from '../../viewModels/validatedViewModel';

@Injectable({
  providedIn: 'root'
})
export class CheckpointTemplateService {
  private baseUrl: string = '';

  constructor(private readonly httpClient: HttpClient, private readonly configuration: Configuration) {
    this.baseUrl = this.configuration.buildEndpoint('CheckpointTemplate/');
  }

  add(viewModel: CheckpointTemplateViewModel): Observable<ValidatedViewModel> {
    return this.httpClient.post<ValidatedViewModel>(`${this.baseUrl}Add`, viewModel);
  }

  update(viewModel: CheckpointTemplateViewModel): Observable<CheckpointTemplateViewModel> {
    return this.httpClient.put<CheckpointTemplateViewModel>(`${this.baseUrl}Update`, viewModel);
  }

  delete(checkpointTemplateId: number): Observable<CheckpointTemplateViewModel> {
    return this.httpClient.delete<CheckpointTemplateViewModel>(`${this.baseUrl}Delete/${checkpointTemplateId}`);
  }

  deleteMutiple(checkpointTemplateIds: number[]): Observable<CheckpointTemplateViewModel> {
    return this.httpClient.post<CheckpointTemplateViewModel>(`${this.baseUrl}DeleteMutiple`, checkpointTemplateIds);
  }

  getList(): Observable<CheckpointTemplateViewModel[]> {
    return this.httpClient.get<CheckpointTemplateViewModel[]>(`${this.baseUrl}GetList`);
  }
}
